<template>
  <Modal :value="modalOpen" :close="false" :title="title">
    <b-row>
      <div class="container" @click="goToConfiguracao()">
        <b-col lg="1">
          <CloseIcon v-if="!configuracao" class="icon-2x" />
          <CheckBold v-else class="icon-2x" />
        </b-col>
        <b-col md="3" lg="11" sm="3">
          <h3>Configurações</h3>
        </b-col>
      </div>
    </b-row>
    <b-row>
      <div class="container" @click="goToEmissor()">
        <b-col lg="1">
          <CloseIcon v-if="!emissor" class="icon-2x" title="Fechar" />
          <CheckBold v-else class="icon-2x" title="Salvar" />
        </b-col>
        <b-col md="3" lg="11" sm="3">
          <h3>Emissor</h3>
        </b-col>
      </div>
    </b-row>
    <div class="confirm-buttons">
      <Button type="error" @click="goToDashboard()">Sair do PDV</Button>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex';
import { Modal } from '@/components';
import { Button } from '@/components/Form';
import CloseIcon from 'vue-material-design-icons/Close';
import CheckBold from 'vue-material-design-icons/Check';

export default {
  name: 'ModalPreValidationNfe',
  components: {
    Modal,
    Button,
    CloseIcon,
    CheckBold,
  },
  props: {
    title: {
      type: String,
      default:
        'Antes de iniciar a emissão de suas notas verifique as informações abaixo:',
    },
    parentComponentFunctionWhenSend: {
      type: Function,
      default: null,
    },
    parentComponentFunctionWhenClose: {
      type: Function,
      default: null,
    },
  },
  computed: {
    ...mapState('nfe', ['preValidationNfe']),
    ...mapState('subscription', ['isPlan360']),
  },
  data() {
    return {
      modalOpen: false,
      emissor: true,
      configuracao: true,
    };
  },
  methods: {
    checkPreValidationsNfe() {
      const { emissor, configuracao } = this.preValidationNfe;
      this.modalOpen = this.isPlan360 && (!emissor || !configuracao);
    },
    goToDashboard() {
      window.location.href = '/#/dashboard';
    },
    setEmissor() {
      this.emissor = this.preValidationNfe.emissor;
    },
    setConfiguracao() {
      this.configuracao = this.preValidationNfe.configuracao;
    },
    goToConfiguracao() {
      window.location.href = '/v2.html#/fiscal/configuration';
    },
    goToEmissor() {
      window.location.href = '/#/account/edit/certificate';
    },
  },
  mounted() {
    this.setEmissor();
    this.setConfiguracao();
    this.checkPreValidationsNfe();
  },
};
</script>

<style scoped>
.material-design-icon.icon-2x {
  height: 3em;
  width: 3em;
}

.material-design-icon.icon-2x > .material-design-icon__svg {
  height: 3em;
  width: 3em;
}

.container {
  display: flex;
  align-items: center;
}

.container:hover {
  cursor: pointer;
}
</style>
